import {
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import reducers from './reducers';
import { baseApi } from './rtk/baseApi';

const store = configureStore({
  reducer: reducers,
  middleware: [logger, thunk, baseApi.middleware],
});

export const useSelector = useReduxSelector;

export const useDispatch = () => useReduxDispatch();

export default store;
